import React from "react";
import {useTranslation} from "react-i18next";
import LockerImg from "../../images/locker-image.png";

const LockerCard = ({lockerDetails}) => {
  const {t} = useTranslation();
  const numberProducts = lockerDetails.numberOfProducts || 0;
  return (
    <div className="bg-white rounded-[16px] shadow-md p-6 w-full max-w-[360px] mx-auto text-center space-y-6 h-[85%] font-[Lato,sans-serif]">
      <div className="space-y-2 mt-6">
        <div className="text-[#333333] text-[24px] font-bold leading-[120%] text-center mt-4">
          {numberProducts >= 2 ? (
            <>
              {t("lockerHeader1Plural")}
              <br />
              {t("lockerHeader2Plural")}
            </>
          ) : (
            <>
              {t("lockerHeader1")}
              <br />
              {t("lockerHeader2")}
            </>
          )}
        </div>
        <div className="text-[#333333] text-[17px] font-normal leading-[150%] mt-2">
          {t("lockerSubHeader1")}{" "}
          <span className="font-bold">{t("qrCode")}</span>,<br />
          {t("lockerSubHeader2")}
        </div>
      </div>
      <div className="flex justify-center">
        <img
          src={LockerImg}
          alt="Módulo de retiro"
          className="w-[140px] mt-4 mb-6"
        />
      </div>
      <div className="text-[#666666] text-[17px] font-normal leading-[150%] mt-6">
        {t("lockerFooter1")}
        <br />
        {t("lockerFooter2")}
      </div>
    </div>
  );
};

export default LockerCard;
